export default "__VITE_ASSET__BrwZthWT__"